export default __webpack_public_path__ + "static/media/marke_1.880ba6dd.png";